import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Plugins } from '@capacitor/core';
import { MenuController, ModalController } from '@ionic/angular';
// import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './core/auth/auth.service';
import { UserService } from './core/user.service';
import { PrivacyPolicyPage } from './privacy-policy/privacy-policy.page';
import { TermsOfServicePage } from './terms-of-service/terms-of-service.page';
import { VehiclesService } from './vehicles/vehicles.service';



const { Device, SplashScreen, StatusBar} = Plugins;
/// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
// import { StatusBar } from '@ionic-native/status-bar/ngx';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  public appPages = [{
      title: 'HOME',
      url: '/app/home',
      icon: 'home'
    },
    {
      title: 'INCIDENTS',
      url: '/app/incidents',
      icon: 'notifications'
    },
    {
      title: 'MY_VEHICLES',
      url: '/app/vehicles',
      icon: 'car'
    },
    {
      title: 'MY_ACCOUNT',
      url: '/app/account',
      icon: 'person'
    }

  ];

  public user: any;

  constructor(
    // private platform: Platform,
    // private splashScreen: SplashScreen,
    // private statusBar: StatusBar,
    private authService: AuthService,
    private userService: UserService,
    public router: Router,
    public modalController: ModalController,
    public translate: TranslateService,
    private http: HttpClient,
    private vehiclesService: VehiclesService,
    private menu: MenuController

  ) {
    this.setLanguage();
    this.initializeApp();
    this.userService.user.subscribe(user => this.user = user);
    
    
  }
  async initializeApp() {
    try {
      await SplashScreen.hide();
      //  await SplashScreen.show({autoHide: true, fadeOutDuration: 2000});

      //const info = Device.getInfo();

      console.log("@@@@@@@----> Ver: 1.9");
    } catch (err) {
      console.log('This is normal in a browser', err);
    }
  }
  // initializeApp1() {
  //   this.platform.ready().then(() => {
  //     // this.statusBar.styleDefault();
  //     // this.splashScreen.hide();
  //   });
  //   const info = Device.getInfo();
  //   console.log("info:", info);
  //   console.log("@@@@@@@----> Ver: 1.8");

  //   // firebase.auth().getRedirectResult().then(authData => {
  //   //   console.log("en App", authData);
  //   //   if(authData.user){
  //   //     let isNew = authData.additionalUserInfo.isNewUser;
  //   //     let user = this.authService.mapProviderToUser(authData);
  //   //     console.log("en app user", user);
  //   //     this.userService.upsertUserLogin(user)
  //   //     .then(()=>{
  //   //       this.router.navigate(['']);
  //   //     })
  //   //     .catch(err=>{console.log(err)});


  //   //   }

  //   // }).catch(function (error) {
  //   //   console.log(error);
  //   // });
  //     // // Result from Redirect auth flow.
  //     // // [START getidptoken]
  //     // firebase.auth().getRedirectResult().then(function(result) {
  //     //   console.log("result", result);
  //     //   if (result.credential) {
  //     //     // This gives you a Google Access Token. You can use it to access the Google API.
  //     //     var token = result.credential['accessToken'];
  //     //     // [START_EXCLUDE]
  //     //     //document.getElementById('quickstart-oauthtoken').textContent = token;
  //     //   } else {
  //     //     //document.getElementById('quickstart-oauthtoken').textContent = 'null';
  //     //     // [END_EXCLUDE]
  //     //   }
  //     //   // The signed-in user info.
  //     //   var user = result.user;
  //     // }).catch(function(error) {
  //     //   // Handle Errors here.
  //     //   var errorCode = error.code;
  //     //   var errorMessage = error.message;
  //     //   // The email of the user's account used.
  //     //   var email = error.email;
  //     //   // The firebase.auth.AuthCredential type that was used.
  //     //   var credential = error.credential;
  //     //   // [START_EXCLUDE]
  //     //   if (errorCode === 'auth/account-exists-with-different-credential') {
  //     //     alert('You have already signed up with a different auth provider for that email.');
  //     //     // If you are using multiple auth providers on your app you should handle linking
  //     //     // the user's accounts here.
  //     //   } else {
  //     //     console.error(error);
  //     //   }
  //     //   // [END_EXCLUDE]
  //     // });
  //     // // [END getidptoken]
  // }
  close() {
    this.menu.close();
  }

  doLogout() {
    this.authService.doLogout()
    .then(res => this.router.navigate(['auth/login']));
    //https://github.com/baumblatt/capacitor-firebase-auth/issues/27
    //https://github.com/baumblatt/capacitor-firebase-auth
  }



  async showPrivacyModal() {
    const modal = await this.modalController.create({
      component: PrivacyPolicyPage
    });
    return await modal.present();
  }
  async showTermsModal() {
    const modal = await this.modalController.create({
      component: TermsOfServicePage
    });
    return await modal.present();
  }
  setLanguage() {
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('en');


    Device.getLanguageCode()
      .then(res => {
        //Modo temporal para especificar el idioma segun el dis`positivo
        // console.log(res.value.substring(0,2));
        // this.translate.use(res.value.substring(0, 2));
        this.translate.use('es');
      })
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    //this.translate.use('en');

    // this is to determine the text direction depending on the selected language
    // for the purpose of this example we determine that only arabic and hebrew are RTL.
    // this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
    //   this.textDir = (event.lang === 'ar' || event.lang === 'iw') ? 'rtl' : 'ltr';
    // });
  }


  public openUrl(urlType: string): void {

    const obs$ = this.translate.get('URL.' + urlType)
      .pipe()
      .subscribe(url => {
        if (urlType == 'MAIL_CONTACT') { //Test idea mails dinamicos con los idiomas
          const mail = {
            to: encodeURIComponent(url.TO),
            subject: encodeURIComponent(url.SUBJECT),
            body: encodeURIComponent(url.BODY)
          }
          console.log(url,mail);
          window.location.href = 'mailto:' + mail.to + '?subject=' + mail.subject + '&body=' + mail.body ;

        } else {
          window.open(url);
        }
      });
      obs$.unsubscribe();
  }



  lottieLoad(ref?){

    console.log("aquí abro si quiero cargar un lottie")
    if (ref) {
      ref.play();
    }
  }

  // completeTest(ref){
  //   ref.stop();
  // }
}